'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var noflakeSchema = require('./noflakeSchema.js');
var _toConsumableArray = _interopDefault(require('@babel/runtime/helpers/toConsumableArray'));
var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));
var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var _asyncToGenerator = _interopDefault(require('@babel/runtime/helpers/asyncToGenerator'));
var _regeneratorRuntime = _interopDefault(require('@babel/runtime/regenerator'));
var React = require('react');
var React__default = _interopDefault(React);
var deviceProfiler = _interopDefault(require('@narvar/device-profiler'));
var createCtx = _interopDefault(require('@narvar/nth-hook-context'));
var storage = require('./storage.js');
var decamelize = require('./decamelize.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function (NarvarEventTypes) {
  NarvarEventTypes["CLICK"] = "click";
  NarvarEventTypes["COMPONENT_RENDER"] = "component_render";
  NarvarEventTypes["PAGE_LOAD"] = "page_load";
  NarvarEventTypes["WEB_VITAL"] = "web_vital";
  NarvarEventTypes["SESSION_START"] = "session_start";
  NarvarEventTypes["ERROR"] = "error";
})(exports.NarvarEventTypes || (exports.NarvarEventTypes = {}));
(function (NarvarClickTypes) {
  NarvarClickTypes["OUTGOING"] = "outgoing";
  NarvarClickTypes["INTERACTION"] = "interaction";
})(exports.NarvarClickTypes || (exports.NarvarClickTypes = {}));
(function (NarvarClickSubTypes) {
  NarvarClickSubTypes["DISMISS"] = "dismiss";
  NarvarClickSubTypes["EXTERNAL_HELP_LINK"] = "external_help_link";
  NarvarClickSubTypes["EXTERNAL_RETAILER_LINK"] = "external_retailer_link";
  NarvarClickSubTypes["EXTERNAL_TRACKING_LINK"] = "external_tracking_link";
  NarvarClickSubTypes["EXTERNAL_LINK"] = "external_link";
  NarvarClickSubTypes["HIDE_SHIPPING_HISTORY"] = "hide_shipping_history";
  NarvarClickSubTypes["LOGO_ASSET"] = "logo_asset";
  NarvarClickSubTypes["COPY_LINK"] = "copy_link";
  NarvarClickSubTypes["SEND_EMAIL"] = "send_email";
  NarvarClickSubTypes["MARKETING_ASSET"] = "marketing_asset";
  NarvarClickSubTypes["MORE_INFORMATION_LINK"] = "more_information_link";
  NarvarClickSubTypes["NAVIGATION_ELEMENT"] = "navigation_element";
  NarvarClickSubTypes["SHOW_SHARING_OPTIONS"] = "show_sharing_options";
  NarvarClickSubTypes["PICKUP_LOCATION_DIRECTIONS_LINK"] = "pickup_location_directions_link";
  NarvarClickSubTypes["PICKUP_LOCATION_PHONE_LINK"] = "pickup_location_phone_link";
  NarvarClickSubTypes["PICKUP_LOCATION_SHOW_HOURS_LINK"] = "pickup_location_show_hours_link";
  NarvarClickSubTypes["PICKUP_LOCATION_HIDE_HOURS_LINK"] = "pickup_location_hide_hours_link";
  NarvarClickSubTypes["RATING"] = "rating";
  NarvarClickSubTypes["SHOW_SHIPPING_HISTORY"] = "show_shipping_history";
  NarvarClickSubTypes["SHARE_LINK"] = "share_link";
  NarvarClickSubTypes["SMS_NUMBER_UPDATE"] = "sms_number_update";
  NarvarClickSubTypes["SMS_SIGNUP"] = "sms_signup";
  NarvarClickSubTypes["SMS_SIGNUP_AGAIN"] = "sms_signup_again";
  NarvarClickSubTypes["SMS_UNSUBSCRIBE"] = "sms_unsubscribe";
  NarvarClickSubTypes["EMAIL_UPDATE"] = "email_update";
  NarvarClickSubTypes["EMAIL_SIGNUP"] = "email_signup";
  NarvarClickSubTypes["EMAIL_SIGNUP_AGAIN"] = "email_signup_again";
  NarvarClickSubTypes["EMAIL_UNSUBSCRIBE"] = "email_unsubscribe";
  NarvarClickSubTypes["SURVEY_SUBMIT"] = "survey_submit";
  NarvarClickSubTypes["PRODUCT_RECOMMENDATIONS"] = "product_recommendations";
  NarvarClickSubTypes["DELIVERY_INSTRUCTIONS"] = "delivery_instructions";
  NarvarClickSubTypes["ITEMS_IN_THIS_SHIPMENT"] = "items_in_this_shipment";
  NarvarClickSubTypes["SHIPMENTS"] = "shipments";
  NarvarClickSubTypes["GIFT_TRACKING"] = "gift_tracking";
  NarvarClickSubTypes["CALLING_DRIVER"] = "calling_driver";
  NarvarClickSubTypes["TEXTING_DRIVER"] = "texting_driver";
})(exports.NarvarClickSubTypes || (exports.NarvarClickSubTypes = {}));
(function (NarvarEventComponents) {
  NarvarEventComponents["NTH_BLOCK_ASSET"] = "nth-block-asset";
  NarvarEventComponents["NTH_BLOCK_BROADCAST_BANNER"] = "nth-block-broadcast-banner";
  NarvarEventComponents["NTH_BLOCK_CUSTOM_COMPONENT"] = "nth-block-custom-component";
  NarvarEventComponents["NTH_BLOCK_DELIVERY_STATUS"] = "nth-block-delivery-status";
  NarvarEventComponents["NTH_BLOCK_DRIVER_DETAILS"] = "nth-block-driver-details";
  NarvarEventComponents["NTH_BLOCK_EDD"] = "nth-block-edd";
  NarvarEventComponents["NTH_BLOCK_HELP_PILL"] = "nth-block-help-pill";
  NarvarEventComponents["NTH_BLOCK_MAPTILER_MAP"] = "nth-block-maptiler-map";
  NarvarEventComponents["NTH_BLOCK_NOTIFICATION_CENTER_DISCLAIMER_TEXT"] = "nth-block-notification-center-disclaimer-text";
  NarvarEventComponents["NTH_BLOCK_SECTION_DIVIDER"] = "nth-block-section-divider";
  NarvarEventComponents["NTH_BLOCK_STAR_RATING"] = "nth-block-star-rating";
  NarvarEventComponents["NTH_BLOCK_TELEPHONE_INPUT"] = "nth-block-telephone-input";
  NarvarEventComponents["NTH_BLOCK_TRACKING_STATUS"] = "nth-block-tracking-status";
  NarvarEventComponents["NTH_BUNDLE_DYNAMIC_HEADER"] = "nth-bundle-dynamic-header";
  NarvarEventComponents["NTH_BUNDLE_NARVAR_FOOTER"] = "nth-bundle-narvar-footer";
  NarvarEventComponents["NTH_BUNDLE_SHIPPING_ACTIVITY"] = "nth-bundle-shipping-activity";
  NarvarEventComponents["NTH_KIT_DYNAMIC_LAYOUT"] = "nth-kit-dynamic-layout";
  NarvarEventComponents["NTH_PACK_EDD_PANEL"] = "nth-pack-edd-panel";
  NarvarEventComponents["NTH_PACK_FEEDBACK"] = "nth-pack-feedback";
  NarvarEventComponents["NTH_PACK_GIFT_TRACKING"] = "nth-pack-gift-tracking";
  NarvarEventComponents["NTH_PACK_NOTIFICATION_CENTER"] = "nth-pack-notification-center";
  NarvarEventComponents["NTH_PACK_EMAIL_NOTIFICATION_CENTER"] = "nth-pack-email-notification-center";
  NarvarEventComponents["NTH_PACK_APP_PUSH_NOTIFICATION_CENTER"] = "nth-pack-app-push-notification-center";
  NarvarEventComponents["NTH_PACK_ITEMS_IN_THIS_SHIPMENT"] = "nth-pack-items-in-this-shipment";
  NarvarEventComponents["NTH_PACK_MORE_INFORMATION"] = "nth-pack-more-information";
  NarvarEventComponents["NTH_PACK_PICKUP_LOCATION"] = "nth-pack-pickup-location";
  NarvarEventComponents["NTH_PACK_SHIPMENTS"] = "nth-pack-shipments";
})(exports.NarvarEventComponents || (exports.NarvarEventComponents = {}));
var MULTIPLE_COMPONENTS = 'multiple-components';
var MULTIPLE_FEATURES = 'multiple-features';
var DEFAULT_ANALYTICS_CONTEXT = {
  data: {
    eventSchema: '',
    pageRetailerMoniker: '',
    productName: '',
    tag: noflakeSchema.NoflakeTag.BAD
  },
  noflakeUrl: 'https://noflake-aggregator-http.narvar.qa/noflake',
  errorCallback: function errorCallback(err) {
    return console.error(err);
  } // eslint-disable-line no-console
};

var QUEUE_INTERVAL = 1;
var COMPONENT_RENDER_QUEUE_INTERVAL = 5000;
var componentRenderEvent;
var eventQueue = [];
var dequeueing = false;
var guidStorage = storage.default(storage.StorageType.LOCAL_STORAGE, storage.Keyspace.GUID);
var requestUuidStorage = storage.default(storage.StorageType.SESSION_STORAGE, storage.Keyspace.REQUEST_UUID);
var postToNoflake = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var data, noflakeUrl, errorCallback, _ref3, id, _ref3$dateCreated, guidDateCreated, guid, requestUuid, _yield$deviceProfiler, clientBrowserFingerprint, clientBrowserName, clientBrowserVersion, clientDeviceMemGb, clientDeviceModel, clientDeviceNetSpeedMbps, clientDeviceNetType, clientDeviceNumProcessors, clientDeviceSizePx, clientDeviceTouchpoints, clientDeviceType, clientDeviceVendor, clientBrowserLanguage, clientDeviceOsName, clientDeviceOsVersion, clientDeviceTimeOffsetMinsToUtc, _window, _window$document, pageReferrerUrl, pageTitle, pageUrl, _window$navigator$ven, clientDeviceNavigatorVendor, pageHost, providedData, payload, noflakePayload;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = _ref.data, noflakeUrl = _ref.noflakeUrl, errorCallback = _ref.errorCallback;
            _ref3 = guidStorage.get(errorCallback) || {}, id = _ref3.id, _ref3$dateCreated = _ref3.dateCreated, guidDateCreated = _ref3$dateCreated === void 0 ? null : _ref3$dateCreated;
            guid = id || '';
            requestUuid = requestUuidStorage.get(errorCallback) || null;
            _context.next = 6;
            return deviceProfiler;
          case 6:
            _yield$deviceProfiler = _context.sent;
            clientBrowserFingerprint = _yield$deviceProfiler.browser_fingerprint;
            clientBrowserName = _yield$deviceProfiler.browser_name;
            clientBrowserVersion = _yield$deviceProfiler.browser_version;
            clientDeviceMemGb = _yield$deviceProfiler.device_mem_gb;
            clientDeviceModel = _yield$deviceProfiler.device_model;
            clientDeviceNetSpeedMbps = _yield$deviceProfiler.device_net_speed_mbps;
            clientDeviceNetType = _yield$deviceProfiler.device_net_type;
            clientDeviceNumProcessors = _yield$deviceProfiler.device_num_processors;
            clientDeviceSizePx = _yield$deviceProfiler.device_size_px;
            clientDeviceTouchpoints = _yield$deviceProfiler.device_touchpoints;
            clientDeviceType = _yield$deviceProfiler.device_type;
            clientDeviceVendor = _yield$deviceProfiler.device_vendor;
            clientBrowserLanguage = _yield$deviceProfiler.language;
            clientDeviceOsName = _yield$deviceProfiler.os_name;
            clientDeviceOsVersion = _yield$deviceProfiler.os_version;
            clientDeviceTimeOffsetMinsToUtc = _yield$deviceProfiler.time_offset_mins_to_utc;
            _window = window, _window$document = _window.document, pageReferrerUrl = _window$document.referrer, pageTitle = _window$document.title, pageUrl = _window.location.href, _window$navigator$ven = _window.navigator.vendor, clientDeviceNavigatorVendor = _window$navigator$ven === void 0 ? null : _window$navigator$ven, pageHost = _window.origin;
            providedData = {
              clientBrowserFingerprint: clientBrowserFingerprint,
              clientBrowserLanguage: clientBrowserLanguage,
              clientBrowserName: clientBrowserName,
              clientBrowserVersion: clientBrowserVersion,
              clientDeviceMemGb: clientDeviceMemGb,
              clientDeviceModel: clientDeviceModel,
              clientDeviceNetSpeedMbps: clientDeviceNetSpeedMbps,
              clientDeviceNetType: clientDeviceNetType,
              clientDeviceNumProcessors: clientDeviceNumProcessors,
              clientDeviceOsName: clientDeviceOsName,
              clientDeviceOsVersion: clientDeviceOsVersion,
              clientDeviceSizePx: clientDeviceSizePx,
              clientDeviceTimeOffsetMinsToUtc: clientDeviceTimeOffsetMinsToUtc,
              clientDeviceTouchpoints: clientDeviceTouchpoints,
              clientDeviceType: clientDeviceType,
              clientDeviceVendor: clientDeviceVendor || clientDeviceNavigatorVendor,
              deviceId: guid,
              eventTs: new Date().toISOString(),
              guid: guid,
              guidDateCreated: guidDateCreated,
              pageHost: pageHost,
              pageReferrerUrl: pageReferrerUrl,
              pageTitle: pageTitle,
              pageUrl: pageUrl,
              requestUuid: requestUuid
            };
            payload = _objectSpread(_objectSpread({
              // Required
              eventType: '',
              // Optional
              clickAssetId: null,
              clickAssetMultilinkId: null,
              clickAssetSchdEndDateUtc: null,
              clickAssetSchdStartDateUtc: null,
              clickAssetType: null,
              clickAssetUrl: null,
              clickCategory: null,
              clickDeliveryInstructionsComment: null,
              clickDeliveryInstructionsLocation: null,
              clickLinkDestinationUrl: null,
              clickLinkLabel: null,
              clickLocationId: null,
              clickNotificationIsChangeNumber: null,
              clickNotificationIsOptIn: null,
              clickNotificationIsOptOut: null,
              clickNotificationIsOrderLevelSignup: null,
              clickProductRecItemData: null,
              clickProductRecItemIndex: null,
              clickProductRecItemName: null,
              clickRedirectSuccessLocation: null,
              clickRedirectSuccessName: null,
              clickSubType: null,
              clickSurveyComment: null,
              clickSurveyRating: null,
              clickType: null,
              clientCity: null,
              clientCountry: null,
              clientLat: null,
              clientLong: null,
              clientRegion: null,
              config: null,
              customerId: null,
              displayedEddBegin: null,
              displayedEddEnd: null,
              displayedLocations: null,
              eventCarrierMoniker: null,
              eventComponent: null,
              eventFeature: null,
              eventId: null,
              eventItemGroup: null,
              eventNotificationSignUpError: null,
              eventNotificationSmsValidationError: null,
              eventNotificationEmailValidationError: null,
              eventTrackStatus: null,
              eventTrackSubStatus: null,
              eventTrackingNumber: null,
              feature: null,
              ingestionTimestamp: null,
              isFallbackView: null,
              orderNumber: null,
              pageCarrierService: null,
              pageComponent: null,
              pageEddFormatted: null,
              pageHasConciergeSelected: null,
              pageHasEdd: null,
              pageLoadMs: null,
              pageLocaleCountry: null,
              pageLocaleLanguage: null,
              pageOrderNumber: null,
              pageShipmentStatus: null,
              pageTrackType: null,
              pageUiLoadMs: null,
              pageUrlLocale: null,
              pageVersionName: null,
              provider: null,
              requestPage: null,
              requestSource: null,
              segmentId: null,
              segmentName: null,
              trackEddBegin: null,
              trackEddEnd: null,
              trackEddSource: null,
              trackLayout: null,
              zipcodeLocation: null
            }, data), providedData); // Merge analytics payload with noflake schema, decamelizing at the same time
            noflakePayload = Object.entries(payload).reduce(function (acc, _ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                camelKey = _ref5[0],
                value = _ref5[1];
              var _decamelize = decamelize.default(camelKey, value),
                _decamelize2 = _slicedToArray(_decamelize, 2),
                snakeKey = _decamelize2[0],
                noFlakeValue = _decamelize2[1];
              acc[snakeKey] = noFlakeValue;
              return acc;
            }, {});
            _context.prev = 27;
            _context.next = 30;
            return fetch(noflakeUrl, {
              method: 'POST',
              keepalive: true,
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(noflakePayload)
            });
          case 30:
            _context.next = 35;
            break;
          case 32:
            _context.prev = 32;
            _context.t0 = _context["catch"](27);
            errorCallback(_context.t0);
          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[27, 32]]);
  }));
  return function postToNoflake(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var dequeue = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var analyticsEvent;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            analyticsEvent = eventQueue[0];
            if (!(analyticsEvent && analyticsEvent.data !== DEFAULT_ANALYTICS_CONTEXT.data && !dequeueing)) {
              _context2.next = 13;
              break;
            }
            _context2.prev = 2;
            dequeueing = true;
            _context2.next = 6;
            return postToNoflake(analyticsEvent);
          case 6:
            eventQueue.shift();
            dequeueing = false;
            _context2.next = 13;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](2);
            // eslint-disable-next-line no-console
            console.error('Error posting to noflake:', _context2.t0);
          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 10]]);
  }));
  return function dequeue() {
    return _ref6.apply(this, arguments);
  };
}();

// TODO: refactor instead of disabling
// eslint-disable-next-line @typescript-eslint/no-misused-promises
var dequeInterval = setInterval(dequeue, QUEUE_INTERVAL);
var enqueueComponentRender = function enqueueComponentRender() {
  if (!componentRenderEvent) return;
  eventQueue.push(componentRenderEvent);
  componentRenderEvent = null;
};
var enqueueComponentRenderInterval = setInterval(enqueueComponentRender, COMPONENT_RENDER_QUEUE_INTERVAL);
var setDequeInterval = function setDequeInterval(ms) {
  clearInterval(dequeInterval);
  // TODO: refactor instead of disabling
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  dequeInterval = setInterval(dequeue, ms);
};
var setEnqueueComponentRenderInterval = function setEnqueueComponentRenderInterval(ms) {
  clearInterval(enqueueComponentRenderInterval);
  enqueueComponentRenderInterval = setInterval(enqueueComponentRender, ms);
};
var flushAnalyticsQueue = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(eventQueue.length > 0)) {
              _context3.next = 5;
              break;
            }
            _context3.next = 3;
            return postToNoflake(eventQueue[0]);
          case 3:
            _context3.next = 0;
            break;
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function flushAnalyticsQueue() {
    return _ref7.apply(this, arguments);
  };
}();
var _createCtx = createCtx(DEFAULT_ANALYTICS_CONTEXT),
  _createCtx2 = _slicedToArray(_createCtx, 2),
  AnalyticsContext = _createCtx2[0],
  AnalyticsProvider = _createCtx2[1];
var useAnalyticsContext = function useAnalyticsContext() {
  return React.useContext(AnalyticsContext);
};
var useAnalyticsPost = function useAnalyticsPost() {
  var context = React.useContext(AnalyticsContext);
  var logEvent = React.useCallback(function (data) {
    if (typeof window === 'undefined') return;
    var _context$state = context.state,
      contextData = _context$state.data,
      noflakeUrl = _context$state.noflakeUrl,
      errorCallback = _context$state.errorCallback,
      _context$state$skip = _context$state.skip,
      skip = _context$state$skip === void 0 ? false : _context$state$skip;
    if (skip === true) return;
    var s4 = function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    };
    var id = "".concat(s4() + s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4() + s4() + s4());

    // guid will be set the first time we initialize analytics context
    if (guidStorage.isEmpty(errorCallback) || guidStorage.isExpired(errorCallback)) {
      guidStorage.set({
        id: id,
        dateCreated: new Date().toISOString()
      }, errorCallback);
    }
    if (requestUuidStorage.isEmpty(errorCallback)) {
      requestUuidStorage.set(id, errorCallback);
    }
    if (data.eventType === exports.NarvarEventTypes.COMPONENT_RENDER && contextData.eventSchema === noflakeSchema.NoflakeTag.COMPONENT_PLATFORM) {
      var _ref8 = componentRenderEvent || {},
        componentRenderData = _ref8.data,
        _ref8$data = _ref8.data;
      _ref8$data = _ref8$data === void 0 ? {} : _ref8$data;
      var _ref8$data$config = _ref8$data.config,
        config = _ref8$data$config === void 0 ? [] : _ref8$data$config;

      // Merge all component_render events into one main payload.
      // The ...data spread has the potential to overwrite keys from previous
      // payloads, but that's cool since the merged component_render payload
      // shouldn't be used for looking at component details anyways. We just
      // want as much info as possible.
      var renderConfigData = {
        name: data.feature || 'feature name not specified by render context',
        options: ["nth-source:".concat(data.eventComponent)]
      };
      componentRenderEvent = {
        data: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, componentRenderData), contextData), data), {}, {
          config: config && config.length ? [].concat(_toConsumableArray(config), [renderConfigData]) : [renderConfigData]
        }, config && config.length && {
          eventComponent: MULTIPLE_COMPONENTS,
          eventFeature: MULTIPLE_COMPONENTS,
          feature: MULTIPLE_FEATURES,
          pageComponent: MULTIPLE_COMPONENTS
        }),
        noflakeUrl: noflakeUrl,
        errorCallback: errorCallback
      };
      return;
    }
    eventQueue.push({
      data: _objectSpread(_objectSpread({}, contextData), data),
      noflakeUrl: noflakeUrl,
      errorCallback: errorCallback
    });
  }, [context]);
  var logEventRef = React.useRef(logEvent);
  React.useEffect(function () {
    logEventRef.current = logEvent;
  }, [logEventRef, logEvent]);
  return React.useCallback(function () {
    return logEventRef.current.apply(logEventRef, arguments);
  }, [logEventRef]);
};

exports.AnalyticsContext = AnalyticsContext;
exports.AnalyticsProvider = AnalyticsProvider;
exports.COMPONENT_RENDER_QUEUE_INTERVAL = COMPONENT_RENDER_QUEUE_INTERVAL;
exports.DEFAULT_ANALYTICS_CONTEXT = DEFAULT_ANALYTICS_CONTEXT;
exports.QUEUE_INTERVAL = QUEUE_INTERVAL;
exports.flushAnalyticsQueue = flushAnalyticsQueue;
exports.setDequeInterval = setDequeInterval;
exports.setEnqueueComponentRenderInterval = setEnqueueComponentRenderInterval;
exports.useAnalyticsContext = useAnalyticsContext;
exports.useAnalyticsPost = useAnalyticsPost;
